<template>
   <div v-on:keyup.esc="$root.$emit('CLOSESOURCEDIALOG')" class="dialog draggable-item bg-light light  w-100-sm w-100-md w-75-lg w-50-xl h-75" v-cloak>
      <DialogTitle :title="$t('Configure Backup Source')" :defaultTitle="$t('Configure Backup Source')" :subTitle="bkpSource.type_name"
         @closeDialog="$root.$emit('CLOSESOURCEDIALOG')" />
      <!--
         E' stata nascosta questa parte. Da non cancellare perchè potrebbe servire in futuro
         <div class="p-2 h-100" v-show="steps[0]">
                     <h6>{{ $t("Select the type of Drive Image backup you want to configure") }}:</h6>
         
                     <div class="form-group p-2">
                         <input type="radio" data-role="radio"
                             :data-caption="$t('Iperius Drive Image / Disk Cloning / P2V')"
                             name="driveimage_type" checked><br>
                             <small>{{ $t("Image File Format : VHD/VHDX.") }}</small><br>
                             <small>{{ $t("Hard disk cloning: creates an exact copy of an entire disk drive.")}}</small><br>
                             <small>{{ $t("P2V - it can be used to virtualize phisycal machines. The backup file can be immediately booted as an Hyper-V VM Restore of individual files.")}}</small><br>
                             <small>{{ $t("Restore on different hardware.") }}</small>
                     </div>
                 </div>
             -->
      <div v-show="step == STEP_SELECTDRIVES" class="dialog-content overflow">
         <!--INFOMAZIONI INIZIALI PRIMA DELLA RICHIESTA DEI DISCHI-------------------------------------------------------->
         <div class="form-group">
            <h6 class="text-bold">
               <span>{{ $t('Select disks') }}</span>
            </h6>
         </div>
         <!--SELEZIONE DEI DISCHI-------------------------------------------------------->
         <NoDataAvailable v-if="listDriveStatus == $ResultValue.Error"
            :message="$t('No disk available')" class="form-group" />
         <div v-else-if="listDriveStatus == $ResultValue.OK"
            style="min-width: 49vw;" class="form-group overflow">
            <div v-for="disk in bkpSource.driveImgSource" :key="disk.caption" class="border bg-white mb-3 border-2 p-3">
               <label class="text-bold"> <span class='mif-drive' /> <span>
               {{ $t("Disk") }} {{ disk.index }}
               -
               {{ disk.caption }} ({{ disk.type }}) [{{ disk.size | prettyBytes }}]</span></label>
               <!-------------------------------------------------------------------------------------------------->
               <ul data-role="treeview" class="p-0 tree-no-toggle">
                  <li class="tree-node d-flex">
                     <input type="checkbox" data-role="checkbox" v-model="disk.selected" />
                     <ul class="d-flex scroll-x">
                        <li v-for="(partition, index) in disk.partitions" :key="disk.index + '-' + index"
                           class="border bg-white mx-2 mb-3 border-2 overflow"
                           style="min-width: 200px; max-width: 300px">
                           <div class="content pr-2 ">
                              <div class="p-1">
                                 <input type="checkbox" v-on:change="checkDrive(disk, partition)"
                                    v-model.lazy="partition.selected" data-role="checkbox"
                                    :data-caption="partition.visibleLabel"
                                    data-style="1">
                                 <br><small class="reduce-3 m-0" style="white-space: nowrap;">
                                 {{ partition.volumeNotfreeSpace | prettyBytes }}/{{ partition.volumeCapacity | prettyBytes }}
                                 </small>
                              </div>
                              <div>
                                 <div data-role="progress" :data-value="partition.volumeSpacePercent"
                                    data-small="true" data-cls-bar="bg-red" data-cls-back="bg-darkGray"
                                    data-role-progress="true" class="progress small pr-3 ml-1 ">
                                    <div class="bar small bg-dark"
                                       :class="{ 'bg-red': (partition.volumeSpacePercent > 90 && partition.volumeDriveLetter != 'None') }"
                                       :style="{ width: partition.volumeSpacePercent + '%' }"></div>
                                 </div>
                              </div>
                              <div class="pl-2 pr-3">
                                 <span class="reduce-3">
                                 <span
                                    v-bind:class="{ 'mif-windows': partition.volumeIsWinVolume }"></span>
                                 {{ partition.volumeFileSystem }}
                                 </span>
                              </div>
                           </div>
                        </li>
                     </ul>
                  </li>
               </ul>
            </div>
         </div>
         <div class="form-group d-flex flex-row flex-justify-end flex-align-center">
            <div class="d-flex flex-column flex-justify-end mr-3">
               <input :disabled="listDriveStatus == $ResultValue.Running" type="checkbox" v-model="includeRemovableDrives" :data-caption="$t('Include removable drives')" data-role="checkbox" data-caption-position="left"/>
               <input :disabled="listDriveStatus == $ResultValue.Running" type="checkbox" v-model="includeVirtualDisks" :data-caption="$t('Include virtual disks')" data-role="checkbox"  data-caption-position="left"/>
            </div>
            <button v-if="listDriveStatus != $ResultValue.Running" class="button secondary mif-2x" @click="getDisks" :title="$t('Update disks')"><span class="mif-refresh"/></button>
            <div v-else class="p-2">
               <span class="mif-spinner2 ani-spin ml-2" />
            </div>
         </div>
      </div>
      <div v-show="step == STEP_SELECTOPTIONS" class="dialog-content overflow">
         <!--TIPO DI BACKUP-------------------------------------------------------->
         <div class="form-group">
            <span class="text-bold">
            <span>{{ $t('Backup mode') }}</span>
            </span>
            <div class="d-flex flex-justify-between">
               <div v-if="cbtStatus != null" class="w-75 p-1">
                  <label>{{ $t("Type") }}:</label>
                  <select v-if="cbtStatus != null" v-model="backupTypeSelected" @change="onBackupTypeChanged" class="select">
                     <option v-for="backupType in $root.selectValues.driveImageBackupTypes"
                        :disabled="backupType.value != 0 && (!cbtStatus.cbtDriverInstalled || !cbtStatus.cbtProviderInstalled)"
                        :value="backupType" :key="backupType.value">{{ $t(backupType.text) }}
                     </option>
                  </select>
               </div>
               <div class="w-25 p-1">
                  <label>{{ $t("Number of copies") }}:</label>
                  <input type="number" class="input rounded" v-model.number="bkpSource.options.nCopies" :disabled="backupTypeSelected.character == 'F'" v-number v-range="{ min: 1, max: 365 }"/>
               </div>
            </div>
         </div>
         <!--OPZIONI-------------------------------------------------------->
         <div class="form-group d-flex flex-column">
            <span class="text-bold">
            <span>{{ $t('Options') }}</span>
            </span>
            <input v-model="bkpSource.options.createPCNameFolder" type="checkbox" data-role="checkbox"
               :data-caption="$t('Create folder with computer name')">
            <input v-model="bkpSource.options.disableDasdIo" type="checkbox" data-role="checkbox"
               :data-caption="$t('Enable I/O Boundary Checks by the file system')">
            <input v-model="bkpSource.options.resetCBT" type="checkbox" data-role="checkbox" 
               :data-caption="$t('Reset CBT at each backup (a full backup will alwais be performed')" :disabled="bkpSource.options.backupType == 'F' || !bkpSource.options.isCBT">
            <!--<input v-model="bkpSource.enableCompression" type="checkbox" data-role="checkbox"
               :data-caption="$t('Enable Compression')">
               <p>{{ $t("Archive File Custom Name") }} </p>
               <input :disabled="!bkpSource.enableCompression" v-model.lazy="bkpSource.options.archiveFileCustomName"
               type="text" data-role="input">
               <label class="text-small text-muted">{{ $t("If blank, default name will be used") }}</label>
               <input :disabled="!bkpSource.enableCompression" v-model="bkpSource.options.useArchivePassword" type="checkbox"
               data-role="checkbox" :data-caption="$t('Protect zip with Password')">
               <p>{{ $t("Archive Password") }}</p>
               <input data-role="input" class="metro-input" type="password" v-model.trim="bkpSource.options.archivePassword"
               :placeholder="$t('Enter Password')" data-prepend="<span class='mif-lock'></span>" />
               <small class="text-muted">{{ $t("Required") }}</small>-->
         </div>
         <div v-if="cbtStatus != null" class="form-group d-flex flex-column">
            <span class="text-bold">
               <span>{{ $t('Status of CBT components (required for incremental and differential backup)') }}</span>
               <span class="p-1 border-50" data-role="hint" 
                  data-cls-hint="tertiary" data-hint-hide="0"
                  :data-hint-text="$t('CBT (Change Block Tracking) is a feature that allows for faster incremental backups by tracking only the portions of the disk that have actually been modified')">
                  <svg width="18px" height="18px" viewBox="0 0 0.36 0.36" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                     <path fill-rule="evenodd" clip-rule="evenodd" d="M0.193 0.023A0.153 0.153 0 0 1 0.287 0.069a0.159 0.159 0 0 1 0.01 0.211 0.154 0.154 0 0 1 -0.193 0.039 0.158 0.158 0 0 1 -0.07 -0.079 0.16 0.16 0 0 1 -0.005 -0.106 0.158 0.158 0 0 1 0.062 -0.085 0.153 0.153 0 0 1 0.101 -0.026M0.203 0.312a0.133 0.133 0 0 0 0.077 -0.047 0.137 0.137 0 0 0 -0.009 -0.181 0.131 0.131 0 0 0 -0.167 -0.017 0.136 0.136 0 0 0 0.011 0.232 0.131 0.131 0 0 0 0.088 0.013M0.166 0.135h0.028V0.112h-0.028zm0.028 0.022v0.09h-0.028V0.158z"/>
                  </svg>
               </span>
            </span>
            <span class="pt-2">{{ $t('CBT Driver') }} : {{ $t(cbtStatus.cbtDriverInstalled ? "Installed" : "Not installed") }}</span>
            <span class="pt-2">{{ $t('VSS Provider') }} : {{ $t(cbtStatus.cbtProviderInstalled ? "Installed" : "Not installed") }} </span>
         </div>
      </div>
      <div class="dialog-actions">
         <ClientMessageView :commands="['GetDiskInfo']" ref="FMV"/>
         <button class="button secondary" :disabled="step == STEP_SELECTDRIVES" @click="step = STEP_SELECTDRIVES"><span>{{ $t("Back") }}</span></button>
         <button class="button secondary" @click="step = STEP_SELECTOPTIONS" :disabled="!enableNextButton"
            v-disable-tooltip:nextButtonDisabled_message>
         <span>{{ $t("Next") }}</span>
         </button>
         <button class="button secondary" :disabled="step == STEP_SELECTDRIVES" @click="saveSource">{{ $t("Save") }}</button>
         <button class="button secondary" @click="$root.$emit('CLOSESOURCEDIALOG')">{{ $t("Close") }}</button>
      </div>
   </div>
</template>
<script>
import DialogTitle from "../../utils/DialogTitle";
import { isValid, prettyBytes, syncronizeArray, waitSeconds } from "../../../utils/utilitiesmodule";
import NoDataAvailable from "../../utils/NoDataAvailable.vue";
import { DISK_MESSAGES } from "../../../utils/messages";

import { draggableMixin } from '../../../mixins/draggable-mixin'
import ClientMessageView from "../view/ClientMessageView.vue";
import { ClientMessage } from "../../../utils/objects";


export default {

    mixins: [draggableMixin],
    name: "DriveImageSource",
    props: {
        bkpSource: {
            type: Object,
            required: true
        }
    },
    components: {
        "DialogTitle": DialogTitle,
        NoDataAvailable,
        ClientMessageView
    },
    data() {
        return {
            step: 0,
            STEP_SELECTDRIVES: 0,
            STEP_SELECTOPTIONS: 1,

            listDriveStatus: this.$ResultValue.NeverExecuted,

            includeRemovableDrives: false,
            includeVirtualDisks: false,

            visible: false,

            backupTypeSelected: null,
            cbtStatus: null,

            nextButtonDisabled_message: ""
        }
    },
    computed: {
        enableNextButton() {

            if (this.step==this.STEP_SELECTOPTIONS) {
                this.nextButtonDisabled_message="";
                return false;
            }

            if (this.listDriveStatus==this.$ResultValue.OK&&this.bkpSource.driveImgSource.every(disk => !disk.selected&&!disk.indeterminate)) {
                this.nextButtonDisabled_message=this.$t('Select at least one item to include in the backup');
                this.setClientMessage(ClientMessage.info_translated(this.nextButtonDisabled_message));
                return false;
            }
            this.setClientMessage(null);

            return true;
        }
    },
    filters: {
        prettyBytes: function(bytes) {
            return prettyBytes(bytes);
        },
    },

    created() {
        this.backupTypeSelected=this.$root.selectValues.driveImageBackupTypes[0];
        this.onBackupTypeChanged();
        this.getDisks().then(_ => {
            //Se la sorgente è stata aperta in edit, popolo backupTypeSelected
            if (isValid(this.bkpSource.driveImgSource)) {
                this.backupTypeSelected=this.$root.selectValues.driveImageBackupTypes.find(bt => bt.character==this.bkpSource.options.backupType);
            }
        });
    },

    methods: {

        async getDisks() {
            let self=this;

            this.listDriveStatus=this.$ResultValue.Running;
            this.setClientMessage(ClientMessage.wait("Listing disks from host..."));
            var socketResponse=await this.$root.socket("GetDiskInfo", this.includeRemovableDrives, this.includeVirtualDisks, true);
            var newDisks=socketResponse.disks;
            this.cbtStatus=socketResponse.cbt_status;

            //Caso 2 : Aperto in create
            if (newDisks.length==0) {
                this.setClientMessage(ClientMessage.error("An error occurred retrieving disks"));
                self.bkpSource.driveImgSource=newDisks;
                this.step=this.STEP_SELECTDRIVES;
                this.listDriveStatus=this.$ResultValue.Error;

                return;
            }

            if (self.bkpSource.driveImgSource==null) {
                self.bkpSource.driveImgSource=newDisks;
                this.listDriveStatus=this.$ResultValue.OK;
                this.nextButtonDisabled_message=this.$t('Select at least one item to include in the backup');
                this.setClientMessage(ClientMessage.info_translated(this.nextButtonDisabled_message));
                return;

            }

            //Caso 3: Si sta modificando una sorgente già creata, modifico i nuovi dischi
            var oldDisks=self.bkpSource.driveImgSource;

            //self.bkpSource.driveImgSource = this.syncronizeArray(oldDisks, newDisks, 0, null);
            var syncronizationResult=syncronizeArray(this.$ONEServiceType.DriveImage, oldDisks, newDisks);

            self.bkpSource.driveImgSource=syncronizationResult.finalArray;

            syncronizationResult.messages.forEach(async messageObj => {
                self.$root.toast(this.$t(messageObj.message, messageObj.args), "warning");
                await waitSeconds(3);
            });

            if (this.bkpSource.driveImgSource.every(disk => !disk.selected&&!disk.indeterminate)) {
                this.nextButtonDisabled_message=this.$t('Select at least one item to include in the backup');
                this.setClientMessage(ClientMessage.info_translated(this.nextButtonDisabled_message));
            }
            this.listDriveStatus=this.$ResultValue.OK;

        },

        checkAllDrives(disk) {
            disk.indeterminate=false;
            disk.partitions.forEach(partition => {
                partition.selected=disk.selected;
            });
        },
        checkDrive(disk, partition) {
            if (partition.volumeIsWinVolume) {
                disk.partitions.forEach(p => {
                    if (p.volumeIsWinVolume)
                        p.selected=partition.selected;
                })
            }
            disk.selected=disk.partitions.every(p => p.selected);
            disk.indeterminate=disk.selected||disk.partitions.some(p => p.selected);

            if (disk.selected||disk.indeterminate) {
                this.nextButtonDisabled_message="";
                this.setClientMessage(null);
                return;
            }

            if (this.bkpSource.driveImgSource.every(disk => !disk.selected&&!disk.indeterminate)) {
                this.nextButtonDisabled_message=this.$t('Select at least one item to include in the backup');
                this.setClientMessage(ClientMessage.info_translated(this.nextButtonDisabled_message));
            }
        },

        onBackupTypeChanged() {
            this.bkpSource.options.backupType=this.backupTypeSelected.character;
            this.bkpSource.options.isCBT=this.backupTypeSelected.value!=0; // != normale full
            if (this.backupTypeSelected.character=="F") {//FULL patching 
                this.bkpSource.options.nCopies=1;
            }
        },

        saveSource() {
            this.$root.$emit("saveBackupSource", this.bkpSource);
        },

        syncronizeArray(oldArray, newArray, level, parentObj) {
            var array=newArray.map(d => { d.old=false; return d }).concat(oldArray.map(d => { d.old=true; return d }));
            var comparator=level==0? "caption":"volumeDriveLetter";
            array.sort((a, b) => a[comparator]<=b[comparator]? -1:1);


            var a, b;
            for (var i=0; i<array.length-1; i++) {
                a=array[i];
                b=array[i+1];
                console.log(a[comparator]+" "+b[comparator]);

                //Caso 1 : Trovo lo stesso oggetto:
                if (a[comparator]==b[comparator]) {
                    if (a.selected) {
                        b.selected=true;
                        if (level==0) {
                            b.partitions=b.partitions.map(p => {
                                p.selected=true;
                                return p;
                            });
                        }


                    } else if (a.indeterminate) {
                        b.indeterminate=true;
                        b.partitions=this.syncronizeArray(a.partitions, b.partitions, level+1, a);
                    }
                    i++;// ho trovato una coppia -> analizzo la prossima coppia
                    newArray.push(b);
                    continue;
                }

                //Caso 2 : Trovo 2 elementi e a è old, è stato cancellato
                if (a.old) {
                    if (level==0)
                        this.$root.toast(this.$t(DISK_MESSAGES.NOT_FOUND, { 0: a.caption }), "warning");
                    else
                        this.$root.toast(this.$t(DISK_MESSAGES.NOT_FOUND_PARTITION, { 0: a.volumeDriveLetter, 1: parentObj.caption }), "warning");
                    continue;
                }

                //Caso 3: trovo 2 guid diversi e a non è old, a è un disco nuovo
                if (level==0)
                    this.$root.toast(this.$t(DISK_MESSAGES.FOUND_NEW, { 0: a.caption }), "warning");
                else
                    this.$root.toast(this.$t(DISK_MESSAGES.FOUND_NEW_PARTITION, { 0: a.volumeDriveLetter, 1: parentObj.caption }), "warning");
                newArray.push(a);
            }

            return newArray;

        },
        handleInfoRequestDiskJson(disksArray) {

            return disksArray.map(d => {
                d.NofPartitions=d.nofPartitions;
                d.partitions=d.partitions.map(p => {
                    p.indeterminate=false;

                    if (p.volumeDriveLetter!=undefined) {
                        p.GptPartitionStyle=p.gptPartitionStyle;
                        p.StartingOffset=p.startingOffset;
                    } else {
                        p.volumeLabel=p.volumeLabel!=undefined&&p.volumeLabel!=""
                            ? p.volumeLabel
                            :p.gptPartitionStyle;
                        p.volumeDriveLetter="None";
                        p.volumeFreeSpace=p.volumeFreeSpace!=undefined? p.volumeFreeSpace:0;
                        p.volumeCapacity=p.partitionLength;
                        p.volumeIsWinVolume="";
                        p.volumeFileSystem="";
                    }
                    p.volumeNotfreeSpace=p.volumeCapacity-p.volumeFreeSpace;
                    p.volumeSpacePercent=(p.volumeNotfreeSpace*100)/p.volumeCapacity;
                    p.UISize=Math.round(100/d.size*p.volumeCapacity)<15? 15:Math.round(100/d.size*p.volumeCapacity);

                    return p;

                });

                return d;
            });

            /* var disks = [];
            // //creo un oggetto per ogni Disco 
            // //var disksArray = res;
            for (var i = 0; i < disksArray.length; i++) {
                var disk = {};
                disk.index = disksArray[i].index;
                disk.guid = disksArray[i].guid;
                disk.type = disksArray[i].type;
                disk.caption = disksArray[i].caption;
                disk.size = disksArray[i].size;
                disk.selected = disksArray[i].selected;
                disk.NofPartitions = disksArray[i].nofPartitions;
                var partitions = disksArray[i].partitions;
                disk.partitions = [];
                for (var j = 0; j < partitions.length; j++) {
                    var partition = {};
                    if (partitions[j].volumeDriveLetter != undefined) {
                        partition.selected = partitions[j].selected;
                        partition.indeterminate = false;
                        partition.partitionNumber = partitions[j].partitionNumber;
                        partition.volumeDeviceID = partitions[j].volumeDeviceID;
                        partition.volumeLabel = partitions[j].volumeLabel;
                        partition.volumeDriveLetter = partitions[j].volumeDriveLetter;
                        partition.volumeFreeSpace = partitions[j].volumeFreeSpace;
                        partition.volumeCapacity = partitions[j].volumeCapacity;
                        partition.volumeNotfreeSpace = partition.volumeCapacity - partition.volumeFreeSpace;
                        partition.volumeSpacePercent = (partition.volumeNotfreeSpace * 100) / partition.volumeCapacity;
                        partition.volumeIsWinVolume = partitions[j].volumeIsWinVolume;
                        partition.volumeFileSystem = partitions[j].volumeFileSystem;
                        partition.partitionLength = partitions[j].partitionLength;
                        partition.GptPartitionStyle = partitions[j].gptPartitionStyle;
                        partition.StartingOffset = partitions[j].startingOffset;
                        partition.UISize = Math.round(100 / disk.size * partition.volumeCapacity) < 15 ? 15 : Math.round(100 / disk.size * partition.volumeCapacity);
                        disk.partitions.push(partition);

                    } else {
                        partition.selected = partitions[j].selected;
                        partition.indeterminate = false;
                        partition.partitionNumber = partitions[j].partitionNumber;
                        partition.volumeDeviceID = partitions[j].volumeDeviceID;
                        partition.volumeLabel = partitions[j].volumeLabel != undefined && partitions[j].volumeLabel != "" ? partitions[j].volumeLabel : partitions[j].gptPartitionStyle;
                        partition.volumeDriveLetter = "None";
                        partition.volumeFreeSpace = partitions[j].volumeFreeSpace != undefined ? partitions[j].volumeFreeSpace : 0;
                        partition.volumeCapacity = partitions[j].partitionLength;
                        partition.partitionLength = partitions[j].partitionLength;
                        partition.volumeNotfreeSpace = partition.volumeCapacity - partition.volumeFreeSpace;
                        partition.volumeSpacePercent = (partition.volumeNotfreeSpace * 100) / partition.volumeCapacity;
                        partition.volumeIsWinVolume = "";
                        partition.volumeFileSystem = "";
                        partition.GptPartitionStyle = partitions[j].GptPartitionStyle;
                        partition.StartingOffset = partitions[j].StartingOffset;
                        partition.UISize = Math.round(100 / disk.size * partition.volumeCapacity) < 15 ? 15 : Math.round(100 / disk.size * partition.volumeCapacity);
                        disk.partitions.push(partition);
                    }
                }


                disks.push(disk);
            }
            return disks; */
        },

        async setClientMessage(message) {
            for (var s=1; s<=10; s++) {
                if (this.$refs?.FMV) {
                    this.$refs.FMV.setClientMessage(message);
                    return;
                }
                await waitSeconds(0.5);
            }
        }
    }
}
</script>